import React from "react";
import { ReactComponent as FirmwareIconSvg } from "assets/icons/notification/firmware.svg";
import styled from "styled-components";
import { COLORS } from "styles/colors";

export default function FirmwareIcon() {
  return (
    <FirmwareIconSvgWrapper>
      <FirmwareIconSvg />
    </FirmwareIconSvgWrapper>
  );
}

const FirmwareIconSvgWrapper = styled.div`
  color: ${({ theme }) => theme.COLORS.WHITE};
  .outline {
    stroke: ${({ theme }) =>
      theme.value === "dark" ? COLORS.PRIMARY3 : "#C9CCD5"} !important;
  }
  svg {
    margin: -2px -4px 0 0;
  }
`;
